import fetch from '@/utils/fetch';

export function getConnected(params){

    return fetch({
         url:'WebSum/WebSum/getManageOrganizationList',
         method:"post",
         data:params
    })

}

export function getSites(params){

    return fetch({
         url:'WebSum/WebSum/getOrgList',
         method:"post",
         data:params
    })

}

export function goConnect(params){

    return fetch({
         url:'WebSum/WebSum/updateManageOrganization',
         method:"post",
         data:params
    })

}

// 取消关联

export function removeConnect(params){

    return fetch({
         url:'WebSum/WebSum/deleteManageOrganization',
         method:"post",
         data:params
    })

}



// WEBPACK FOOTER //
// ./src/api/pgMent/ccMent.js